export default "__VITE_ASSET__BoVDT2Bq__"